/**
 * Get profile color class based on name
 * Generates consistent colors for user avatars
 * Based on Java's String.hashCode() implementation
 */

const TAILWIND_BG_COLOR = [
  'bg-zinc-500',
  'bg-neutral-500',
  'bg-stone-500',
  'bg-red-500',
  'bg-orange-500',
  'bg-amber-500',
  'bg-yellow-500',
  'bg-lime-500',
  'bg-green-500',
  'bg-emerald-500',
  'bg-teal-500',
  'bg-cyan-500',
  'bg-sky-500',
  'bg-blue-500',
  'bg-indigo-500',
  'bg-violet-500',
  'bg-purple-500',
  'bg-fuchsia-500',
  'bg-pink-500',
  'bg-rose-500',
];

/**
 * Based on Java's String.hashCode() implementation
 * Generates a consistent hash from a string
 */
const stringHashCode = (str: string): number => {
  let hash = 0;
  str = str.toLowerCase(); // case-insensitive

  for (let i = 0; i < str.length; i++) {
    // Equivalent to: hash = hash * 31 + str.charCodeAt(i)
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
    hash = hash & hash; // force 32-bit signed integer
  }

  return hash;
};

/**
 * Get profile color class based on name
 * Returns a consistent color for the same name
 */
export function getProfileColorFromName(name?: string): string {
  const hash = stringHashCode(name || '');
  const index = Math.abs(hash) % TAILWIND_BG_COLOR.length;
  return TAILWIND_BG_COLOR[index];
}
